export const enum UserRegistrationStatechartEvent {
  /**
   * Reset statechart to idle state (after closing and opening popup)
   */
  reset = 'reset',

  /**
   * User wants to register (clicked on register button in form)
   */
  wantToRegister = 'wantToRegister',

  /**
   * User input is valid
   */
  inputIsValid = 'inputIsValid',

  /**
   * Input is not valid
   */
  inputIsNotValid = 'inputIsNotValid',

  /**
   * Captcha value changed
   */
  captchaValueChanged = 'captchaValueChanged',

  /**
   * User registration failed
   */
  registrationFailed = 'registrationFailed',
}
